import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import config from 'config';
import { makeEstimationMessage } from 'modules/conference/selectors/etimatedTimeMessageFormattor';
import Icon from 'shared/components/Icon';

import theme from './ExpectedTimer.scss';


const isClalit = config.product_name === 'clalit';

const propTypes = {
  expectedTime: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

const defaultProps = {};

const ExpectedTimer = ({ expectedTime }) => {
  return (
    <div className={ classnames(theme.container, { [theme.clalitContainer]: true }) }>
      <If condition={ !isClalit }>
        <div className={ theme.icon }>
          <Icon name="clock-outline" />
        </div>
      </If>

      { makeEstimationMessage(expectedTime).formattedDisplayMessage }
    </div>
  );
};


ExpectedTimer.propTypes = propTypes;
ExpectedTimer.defaultProps = defaultProps;


export default ExpectedTimer;
